import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'

export default {
    get () {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Role`, AUTH_HEADERS())
    },
    getById (id) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Role/${id}`, AUTH_HEADERS())
    },

}
